import React from 'react'
import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import Dashboard from './pages/dashboard/Dashboard'
import About from './pages/about/About'
import Login from './pages/login/Login'
import Employers from './pages/employers/Employers'
import CompanyDetails from './pages/employers/CompanyDetails'
import Jobseekers from './pages/jobseekers/Jobseekers'
import KioskReport from './pages/kiosk-report/KioskReport'
import Jobs from './pages/jobs/Jobs'
import JobDetails from './pages/jobs/JobDetails'
import Applications from './pages/applications/Applications'
import ManageUsers from './pages/manage-users/ManageUsers'
import UpdateUser from './pages/manage-users/UpdateUser'
import ForgotPassword from './pages/login/ForgotPassword'
import ResetPassword from './pages/login/ResetPassword'
import Error404NotFound from './pages/404'
import ProfileSettings from './pages/profile-settings/ProfileSettings'
import SetNewPassword from './pages/login/SetNewPassword'
import jwt_decode from 'jwt-decode'
import JobList from './pages/joblist/JobList'
import CreateEditJobIndex from './components/joblist/CreateEditJobIndex'
import ApplicantsList from './components/joblist/ApplicantsList'

const ProtectedRoutes = () => {
	const isLoggedIn = localStorage.getItem('token')
	return isLoggedIn ? <Outlet /> : <Navigate to='/login' />
}
interface decoded {
	role: string
}
const SuperAdminRoutes = ()=>{
	const token = localStorage.getItem('token')
	if (token !== null) {
		const temp: decoded = jwt_decode(token)
		return temp.role === 'E2ISUPERADMIN' ? <Outlet /> : <Navigate to='/' />
	}
	return <Outlet /> 
}
const Router = () => {
	return (
		<Routes>
			<Route path="/login" element={<Login />} />
			<Route path="/forgotpassword" element={<ForgotPassword />} />
			<Route path="/resetpassword/:token" element={<ResetPassword />} />
			<Route path="/setnewpassword/:token" element={<SetNewPassword />} />
			<Route element={<ProtectedRoutes />}>
				<Route path="/" element={<Dashboard />} />
				<Route path="/about" element={<About />} />
				<Route path="/jobseekers" element={<Jobseekers />} />
				<Route path="/kiosk-report" element={<KioskReport />} />
				<Route path="/applications" element={<Applications />} />
				<Route path="/joblist" element={<JobList />} />
				<Route path="/joblist/new" element={<CreateEditJobIndex />} />
				<Route path="/joblist/edit" element={<CreateEditJobIndex />} />
				<Route path="/joblist/applicantslist" element={<ApplicantsList />} />
				<Route element={<SuperAdminRoutes />}>
					<Route path="/employers" element={<Employers />} />
					<Route path="/employers/:id" element={<CompanyDetails />} />
					<Route path="/jobs" element={<Jobs />} />
					<Route path="/jobs/:id" element={<JobDetails />} />
					<Route path="/manage-users" element={<ManageUsers />} />
					<Route path="/update-user/:id" element={<UpdateUser />} />
				</Route>
				<Route path="/profile-settings" element={<ProfileSettings />} />
			</Route>
			<Route path="/*" element={<Error404NotFound />} />
		</Routes>
	)
}

export default Router